// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';

// Utils
import {
    isBlocked,
    isFeedbackOnlyAccess,
    isOwner,
    isReadOnly,
} from '../../../../../../../../common/permissions/permissionUtil';

// Actions
import { openSheet } from '../../../../../../../mobile/structural/sheet/sheetActions';

// Components
import UserDetailsListEntry from '../../../../../../../components/userAvatar/UserDetailsListEntry';
import BoardEditorPermissionUtil from '../BoardEditorPermissionUtil';
import Badge from '../../../../../../../components/misc/Badge';

// Constants
import { SheetId } from '../../../../../../../mobile/structural/sheet/sheetTypes';

// Style
import './BoardEditorListEntry.scss';

const getBadge = (permission) => {
    if (isOwner(permission)) return <Badge className="owner">Owner</Badge>;
    if (isFeedbackOnlyAccess(permission)) return <Badge className="comment">Comment only</Badge>;
    if (isReadOnly(permission)) return <Badge className="read">Read only</Badge>;

    return null;
};

const BoardEditorListEntry = (props) => {
    const { editor = {}, currentBoardEditors, isPhoneOrMobileAppMode } = props;

    const { user, currentlyViewing, permission } = editor;

    if (!user) return null;

    const showPermissionUtil = currentBoardEditors.length > 1;

    const dispatch = useDispatch();

    const handleClick = () => {
        if (isPhoneOrMobileAppMode) dispatch(openSheet(SheetId.BoardEditorPermission, editor.userId));
    };

    return (
        <div className={classNames('BoardEditorListEntry', { blocked: isBlocked(permission) })} onClick={handleClick}>
            <UserDetailsListEntry user={user} currentlyViewing={currentlyViewing} nameBadge={getBadge(permission)} />
            <BoardEditorPermissionUtil show={showPermissionUtil} {...props} {...editor} />
        </div>
    );
};

BoardEditorListEntry.propTypes = {
    editor: PropTypes.object,
    boardEditorTimesFetched: PropTypes.bool,
    isShared: PropTypes.bool,
    currentBoardEditors: PropTypes.array,
    specificUserPermissions: PropTypes.number,
    hasPublicEditPermissions: PropTypes.bool,
    isPhoneOrMobileAppMode: PropTypes.bool,
};

export default BoardEditorListEntry;
